import router from '../router'
import http from './Http'
import logger from './Logger'
import session from './Session'
import store from '../store'
import to from 'await-to-js'

// TODO refactor to async
export default {

  _storeUserState ({user, profile}) {
    store.commit('setAuthenticated', true)
    store.commit('setWuid', profile.wuid)
    store.commit('setUser', user)
  },

  _storeProfileState (profile) {
    store.commit('setWuid', profile.wuid)
    if (profile.id !== undefined) store.commit('setProfile', profile)
  },

  _resetState () {
    store.dispatch('resetLoaded')
    store.commit('setAuthenticated', false)
    store.commit('setWuid', null)
  },

  _shouldReturnBecauseOfError (error) {
    if (error && error.response.data !== undefined) {
      switch (error.response.data.code) {
        case 4001:
        case 4002:
          this._storeProfileState({wuid: error.response.data.details.wuid})
          router.push('register')
          break
        default:
          router.push('error')
      }
      return true
    }
    return false
  },

  isSessionAuthenticated () {
    return store.state.authenticated
  },

  isProfileAuthenticated () {
    return store.state.wuid !== null
  },

  checkServerLoginStatus (next = '/') {
    http.get('m/auth/status')
      .then(({data}) => {
        if (data.status) {
          this._storeUserState(data)
          this._storeProfileState(data.profile)
          router.push(next)
        } else {
          session.pushNextRoute(next)
          window.location.href = data.url
        }
      }).catch(error => {
        console.log(error)
      })
  },

  // Retrieve Wechat Profile by code
  async authenticate (code) {
    if (this.isSessionAuthenticated()) {
      router.push(session.popNextRoute() || '/')
      return
    }
    const [error, response] = await to(http.get('m/auth/profile?code=' + code))
    if (this._shouldReturnBecauseOfError(error)) return

    const {profile, token} = response.data
    this._storeProfileState(profile)
    if (profile.users.length > 1) {
      session.pushProfileAuthToken(token)
      router.push('confirm')
      return
    } else {
      await this.login(profile.users[0].id, token)
    }
  },

  // login specified userid
  async login (userid, token) {
    const [ err, resp ] = await to(http.post('m/auth/confirm', {
      'user_id': userid,
      wuid: store.state.profile.wuid,
      token }))

    if (err) {
      logger.log('error', err)
      router.push('/')
      return
    }

    this._storeUserState(resp.data)
    router.push(session.popNextRoute() || '/')
  },

  async switch (userid) {
    await this._resetState()
    const [ err, resp ] = await to(http.post('m/auth/switch/' + userid))
    if (err) {
      logger.log('error', err)
      router.push('/')
      return
    }

    this._storeUserState(resp.data)
    router.push(session.popNextRoute() || '/')
  },

  async refresh () {
    store.dispatch('refreshAuthStatus')
  },

  logout () {
    this._resetState()
    return http.post('m/auth/logout')
  }

}



// WEBPACK FOOTER //
// ./src/modules/Auth.js